module.exports = __webpack_public_path__ + "static/media/show-gal-5.ded1ce03.jpg";